// @ts-nocheck
import 'element-polyfill';
import { useModel } from '@modern-js/runtime/model';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import userModel from '@/models/user';
import 'intersection-observer';
import './style.less';
import '../app.global.css';
import '@arco-design/web-react/dist/css/arco.css';
import { SENTRY_DSN } from '@/constants';

// 初始化 Sentry
Sentry.init({
  dsn: SENTRY_DSN,
  environment: process.env.DEPLOY_ENV || 'development',
  release: process.env.VERSION || '1.0.0',
  // 设置最大面包屑数量
  maxBreadcrumbs: 50,

  // 设置是否在开发环境启用
  enabled: process.env.NODE_ENV !== 'development',

  // 数据处理回调
  // beforeSend: (event, hint) => {
  //   // 过滤掉一些不需要的错误
  //   const error = hint.originalException;

  //   // 过滤网络错误
  //   if (error?.message?.includes('Network Error')) {
  //     return null;
  //   }

  //   // 过滤CSS脚本加载错误
  //   if (error?.message?.includes('Loading CSS chunk')) {
  //     return null;
  //   }

  //   return event;
  // },
});

// 全局未处理的 Promise 拒绝
window.addEventListener('unhandledrejection', event => {
  // 如果拒绝的值是 HTML（登录页面），不上报
  if (
    typeof event.reason === 'string' &&
    event.reason.includes('<!DOCTYPE html>')
  ) {
    event.preventDefault();
    return;
  }

  Sentry.captureException(event.reason, {
    tags: { type: 'unhandled-promise-rejection' },
  });
});

export default function App({
  Component,
  ...pageProps
}: {
  Component: React.ComponentType;
}) {
  const [{ user, loaded }, { getUserInfo, getPurposeList }] =
    useModel(userModel);

  useEffect(() => {
    const pageGetUserInfo = async () => {
      try {
        await getUserInfo();
      } catch (err) {
        // 记录用户信息获取失败
        Sentry.addBreadcrumb({
          message: 'Failed to get user info',
          category: 'auth',
          level: 'warning',
        });
      }
    };
    pageGetUserInfo();
    getPurposeList();
  }, []);

  // 先 config，后 start，这两个顺序不要变
  useEffect(() => {
    if (user?.userId) {
      // 设置 Sentry 用户信息
      Sentry.setUser({
        id: user.userId,
        ip_address: '{{auto}}', // 自动获取 IP
      });
      window.collectEvent('config', {
        user_unique_id: user.userId,
        user_is_login: user.userId ? 1 : 0,
        evtParams: {
          user_id: user.userId,
        },
      });
      window.userId = user.userId;
    }
  }, [user]);

  // 先 config，后 start，这两个顺序不要变
  useEffect(() => {
    if (loaded && process.env.DEPLOY_ENV === 'prod') {
      window.collectEvent('start');
    }
  }, [loaded]);

  return <Component {...pageProps} />;
}
